@if (initialized && dto) {
    <ei-structure-field-full
            [objectIdentifier]="objectIdentifier"
            [uiMode]="uiMode"
            [dto]="dto"
            [structureFieldDto]="dto"
            (onNavigationItems)="handleNavigationItems($event)"
    ></ei-structure-field-full>
}
